import { render, staticRenderFns } from "./RecipeDetailsForm.vue?vue&type=template&id=883cc1b4&scoped=true&"
import script from "./RecipeDetailsForm.vue?vue&type=script&lang=js&"
export * from "./RecipeDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipeDetailsForm.vue?vue&type=style&index=0&id=883cc1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883cc1b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VChip,VCol,VRow,VSelect,VSimpleTable,VTextField,VTextarea})
